import script from "./ReferralWinnersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferralWinnersPage.vue?vue&type=script&setup=true&lang=js"

import "./ReferralWinnersPage.vue?vue&type=style&index=0&id=76969064&lang=css"

const __exports__ = script;

export default __exports__